import { Typography } from "@mui/material";
import { format } from "date-fns";

import { JournalSupportResponse } from "@/api";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { useTranslation } from "@/translations";

interface Props {
  entry: JournalSupportResponse;
}

export function JournalSupportEntry({ entry }: Props) {
  const { t } = useTranslation();
  const { language } = useLanguageContext();

  const timeLabel = format(entry.endTimeUtc, "HH:mm", { locale: locales[language] });

  return (
    <Typography variant="body2" component="span">
      <strong>{entry.userCode}</strong> {t("common.until")} {timeLabel} {t("common.clock")}
    </Typography>
  );
}
